export class TransactionResult {
    public transactionHash!: string;
}
